<form [formGroup]="commonForm" class="space-y-8" (ngSubmit)="handleFormSubmission()">

    <!-- Responsive grid -->
    <div class="grid grid-cols-1 sm:grid-cols-2 gap-6 sm:gap-8">
        <!-- Nationality -->
        <div>
            <app-custom-dropdown label="COMMON_FORM.NATIONALITY" placeholder="COMMON_FORM.PLEASE_SELECT" [options]="countriesOptions"
                [isSearchable]="true" searchPlaceholder="{{'COMMON_FORM.SEARCH_COUNTRY' |translate}}"
                (optionSelected)="onDropdownSelect('nationality', $event)" customClass="!mb-0"></app-custom-dropdown>
        </div>

        <!-- DOB -->
        <div>
            <app-date-picker label="{{'COMMON_FORM.DOB' | translate}}" placeholder="DD/MM/YYYY" [control]="getControl('dob')"
                [errorMessage]="'COMMON_FORM.INVALID_DATE'" modalTitle="{{'COMMON_FORM.SELECT_DOB' | translate}}">
            </app-date-picker>
        </div>
    </div>

    <!-- If nationality For jordanian, it is compulsary to enter all fields, -->
    <!-- For arabs (non jordanian), compulsary fields will only be first name and surname in arabic and english -->
    <!-- For other countries (aside from arab countries/jordan), only first name and surname in english will be compulsary -->
    <div *ngIf="isNationalitySelected()">
        <p class="text-base font-medium mb-6 sm:col-span-2 text-(--text-muted)">
            {{'COMMON_FORM.AR_NAME' | translate}}
        </p>

        <div class="grid grid-cols-1 sm:grid-cols-2 gap-6 sm:gap-8" dir="rtl">
            <!-- First Name -->
            <div>
                <app-input-field label="الاسم الأول" placeholder="الرجاء الدخول" customClass="!mb-0" forceLang="ar"
                    [control]="getControl('firstNameAr')"  [isRequired]="arabicRequired.includes('firstNameAr')">
                </app-input-field>
            </div>

            <!-- Father's Name -->
            <div>
                <app-input-field label="اسم الأب" placeholder="الرجاء الدخول" customClass="!mb-0" forceLang="ar"
                    [control]="getControl('fatherNameAr')" [isRequired]="arabicRequired.includes('fatherNameAr')">
                </app-input-field>
            </div>

            <!-- Grandfather Name -->
            <div>
                <app-input-field label="اسم الجد" placeholder="الرجاء الدخول" customClass="!mb-0" forceLang="ar"
                    [control]="getControl('grandFatherNameAr')"
                    [isRequired]="arabicRequired.includes('grandFatherNameAr')">
                </app-input-field>
            </div>

            <!-- Surname -->
            <div>
                <app-input-field label="اسم العائلة" placeholder="الرجاء الدخول" customClass="!mb-0" forceLang="ar"
                    [control]="getControl('surnameAr')" [isRequired]="arabicRequired.includes('surnameAr')">
                </app-input-field>
            </div>

        </div>
    </div>

    <div *ngIf="isNationalitySelected()">
        <p class="text-base font-medium mb-6 sm:col-span-2 text-(--text-muted)">
            {{'COMMON_FORM.ENG_NAME' | translate}}
        </p>

        <div class="grid grid-cols-1 sm:grid-cols-2 gap-6 sm:gap-8" dir="ltr">
            <!-- First Name -->
            <div>
                <app-input-field label="First name" placeholder="Please Enter" customClass="!mb-0" forceLang="en"
                    [control]="getControl('firstNameEn')"
                    [isRequired]="englishRequired.includes('firstNameEn')"></app-input-field>
            </div>
            <!-- Father's Name -->
            <div>
                <app-input-field label="Father’s name" placeholder="Please Enter" customClass="!mb-0" forceLang="en"
                    [control]="getControl('fatherNameEn')"
                    [isRequired]="englishRequired.includes('fatherNameEn')"></app-input-field>
            </div>

            <!-- GrandFather name -->
            <div>
                <app-input-field label="Grandfather’s name" placeholder="Please Enter" customClass="!mb-0" forceLang="en"
                    [control]="getControl('grandFatherNameEn')"
                    [isRequired]="englishRequired.includes('grandFatherNameEn')"></app-input-field>
            </div>
            <!-- Surname Name -->
            <div>
                <app-input-field label="Surname" placeholder="Please Enter" customClass="!mb-0" forceLang="en"
                    [control]="getControl('surnameEn')"
                    [isRequired]="englishRequired.includes('surnameEn')"></app-input-field>
            </div>
        </div>
    </div>

    <div *ngIf="formIdentifier.INDIVIDUAL_OWNERS === activeForm || formIdentifier.EXECUTIVE_MANAGEMENT === activeForm">
        <p  class="text-base font-medium mb-6 sm:col-span-2 text-(--text-muted)">
            {{'COMMON_FORM.COMPLIANCE_INFO' | translate}}
        </p>

        <div class="grid grid-cols-1 sm:grid-cols-2 gap-6 sm:gap-8">

            <!-- below fields when active form is of type INDIVIDUAL_OWNERS -->
            <div *ngIf="formIdentifier.INDIVIDUAL_OWNERS === activeForm">
                <app-input-field label="{{ 'COMMON_FORM.INDIVIDUAL_SHARE' | translate }}" type="number"
                    placeholder="{{ 'LOGIN.PLACEHOLDER' | translate }}" customClass="!mb-0"
                    [control]="getControl('individualShare')"></app-input-field>
            </div>

            <!-- below fields when active form is of type EXECUTIVE_MANAGEMENT -->
            <div *ngIf="formIdentifier.EXECUTIVE_MANAGEMENT === activeForm">
                <app-input-field label="{{ 'COMMON_FORM.CORPORATE_SHARE' | translate }}" type="number"
                    placeholder="{{ 'LOGIN.PLACEHOLDER' | translate }}" customClass="!mb-0"
                    [control]="getControl('corporateShare')"></app-input-field>
            </div>
            <div *ngIf="formIdentifier.EXECUTIVE_MANAGEMENT === activeForm">
                <app-custom-dropdown label="COMMON_FORM.POSITION" placeholder="COMMON_FORM.PLEASE_SELECT" [options]="corporatePositionOptions"
                    (optionSelected)="onDropdownSelect('position', $event)" customClass="!mb-0"></app-custom-dropdown>
            </div>
        </div>
    </div>


    <!-- Authorized signatory form section -->
    <div *ngIf="formIdentifier.AUTHORIZED_SIGNATORY === activeForm">
        <p class="text-base font-medium mb-6 sm:col-span-2 text-(--text-muted)">
            {{'COMMON_FORM.AUTH_INFO' | translate}}
        </p>
        <div class="grid grid-cols-1 sm:grid-cols-2 gap-6 sm:gap-8">
            <div>
                <app-custom-dropdown label="COMMON_FORM.AUTHORIZATION" placeholder="COMMON_FORM.PLEASE_SELECT" 
                    [options]="typeOfAuthorizationOptions"
                    (optionSelected)="onDropdownSelect('typeOfAuthorization', $event)"
                    customClass="!mb-0"></app-custom-dropdown>
            </div>
            <div>
                <app-input-field label="{{ 'COMMON_FORM.MIN_AMOUNT' | translate }}" type="number"
                    placeholder="{{ 'LOGIN.PLACEHOLDER' | translate }}" customClass="!mb-0"
                    [control]="getControl('minAuthAmount')"></app-input-field>
            </div>

            <div>
                <app-input-field label="{{ 'COMMON_FORM.MAX_AMOUNT' | translate }}" type="number"
                    placeholder="{{ 'LOGIN.PLACEHOLDER' | translate }}" customClass="!mb-0"
                    [control]="getControl('maxAuthAmount')"></app-input-field>
            </div>
        </div>
    </div>


    <!-- Common section for file upload -->
    <div class="grid grid-cols-1 sm:grid-cols-2 gap-6 sm:gap-8">
        <p class="text-medium mb-0 sm:col-span-2">
            {{'COMMON_FORM.RELATIVE' | translate}}
        </p>
        <!-- radio button group -->
        <app-radio-group [options]="isCloseRelativeOptions" [selectedValue]="commonForm.get('isCloseRelative')?.value"
            (selectedValueChange)="onPepSelection($event)">
        </app-radio-group>

        <!-- National Id -->
        <div class="sm:col-span-2">
            <app-single-file-upload title="COMMON_FORM.NATIONAL_ID" acceptedTypes=".jpg,.png,.pdf,.doc" [maxSizeMB]="5"
                 [control]="getControl('nationalIdDocument')"></app-single-file-upload>
        </div>
        <!-- Proof Of Address -->
        <div class="sm:col-span-2">
            <app-single-file-upload title="COMMON_FORM.ADDRESS_PROOF" acceptedTypes=".jpg,.png,.pdf,.doc" [maxSizeMB]="5" [control]="getControl('proofOfAddressDocument')"></app-single-file-upload>
        </div>
    </div>

    <!-- Submit Button -->
    <app-button text="{{ 'COMMON_FORM.CONFIRM_DETAILS' | translate }}" type="submit" variant="primary" size="lg"
        extraClass="mt-3 mb-12 w-full" [disabled]="commonForm.invalid"></app-button>

</form>